// SPDX-License-Identifier: Apache-2.0
export default class DefaultConsole {
  public static readonly debug: typeof console.debug = console.debug;
  public static readonly log: typeof console.log = console.log;
  public static readonly info: typeof console.info = console.info;
  public static readonly warn: typeof console.warn = console.warn;
  public static readonly error: typeof console.error = console.error;
  public static readonly assert: typeof console.assert = console.assert;
}
